export default [
  {
    name: 'Midsommar',
    daysInAdvance: 30,
    startDate: '2024-06-21',
    endDate: '2024-06-21',
  },
  {
    name: 'Allhelgonahelgen',
    daysInAdvance: 30,
    startDate: '2024-10-31',
    endDate: '2024-11-03',
  },
  {
    name: 'Fars dag',
    daysInAdvance: 30,
    startDate: '2024-11-10',
    endDate: '2024-11-10',
  },
  {
    name: 'Lucia',
    daysInAdvance: 15,
    startDate: '2024-12-13',
    endDate: '2024-12-13',
  },
  {
    name: 'Julafton',
    daysInAdvance: 30,
    startDate: '2024-12-24',
    endDate: '2024-12-24',
  },
  {
    name: 'Juldagen',
    daysInAdvance: 15,
    startDate: '2024-12-25',
    endDate: '2024-12-25',
  },
  {
    name: 'Nyårsafton',
    daysInAdvance: 30,
    startDate: '2024-12-31',
    endDate: '2024-12-31',
  },
  {
    name: 'Tjugondag Knut',
    daysInAdvance: 15,
    startDate: '2025-01-13',
    endDate: '2025-01-13',
  },
  {
    name: 'Alla hjärtans dag',
    daysInAdvance: 30,
    startDate: '2025-02-14',
    endDate: '2025-02-14',
  },
  {
    name: 'Vecka 8',
    daysInAdvance: 15,
    startDate: '2025-02-17',
    endDate: '2025-02-23',
  },
  {
    name: 'Vecka 9',
    daysInAdvance: 15,
    startDate: '2025-02-24',
    endDate: '2025-03-02',
  },
  {
    name: 'Vecka 10',
    daysInAdvance: 15,
    startDate: '2025-03-03',
    endDate: '2025-03-09',
  },
  {
    name: 'Påsk',
    daysInAdvance: 30,
    startDate: '2025-04-18',
    endDate: '2025-04-21',
  },
  {
    name: 'Valborg',
    daysInAdvance: 30,
    startDate: '2025-04-30',
    endDate: '2025-04-30',
  },
  {
    name: 'Första maj',
    daysInAdvance: 30,
    startDate: '2025-05-01',
    endDate: '2025-05-01',
  },
  {
    name: 'Mors dag',
    daysInAdvance: 30,
    startDate: '2025-05-25',
    endDate: '2025-05-25',
  },
  {
    name: 'Nationaldagen',
    daysInAdvance: 30,
    startDate: '2025-06-06',
    endDate: '2025-06-06',
  },
  {
    name: 'Midsommar',
    daysInAdvance: 30,
    startDate: '2025-06-21',
    endDate: '2025-06-21',
  },
  {
    name: 'Kräftor',
    daysInAdvance: 30,
    startDate: '2025-08-01',
    endDate: '2025-08-31',
  },
  {
    name: 'Ostronets dag',
    daysInAdvance: 30,
    startDate: '2025-09-06',
    endDate: '2025-09-06',
  },
  {
    name: 'Champagnens dag',
    daysInAdvance: 30,
    startDate: '2025-10-25',
    endDate: '2025-10-25',
  },
  {
    name: 'Fars dag',
    daysInAdvance: 30,
    startDate: '2025-11-09',
    endDate: '2025-11-09',
  },
  {
    name: 'Mårten gås',
    daysInAdvance: 30,
    startDate: '2025-11-10',
    endDate: '2025-11-10',
  },
  {
    name: 'Beaujolais Nouveau',
    daysInAdvance: 30,
    startDate: '2025-11-20',
    endDate: '2025-11-20',
  },
  {
    name: 'Thanksgiving',
    daysInAdvance: 30,
    startDate: '2025-11-27',
    endDate: '2025-11-27',
  },
  {
    name: 'Lucia',
    daysInAdvance: 30,
    startDate: '2025-12-13',
    endDate: '2025-12-13',
  },
  {
    name: 'Julafton',
    daysInAdvance: 30,
    startDate: '2025-12-24',
    endDate: '2025-12-24',
  },
  {
    name: 'Nyårsafton',
    daysInAdvance: 30,
    startDate: '2025-12-31',
    endDate: '2025-12-31',
  }
]
